if (!customElements.get('product-preview-form')) {
  customElements.define(
    'product-preview-form',
    class ProductPreviewForm extends HTMLElement {
      constructor() {
        super()
        this.onSubmitHandler = this.onSubmitHandler.bind(this)
        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler)
        this.cartPopup = document.querySelector('cart-popup')
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        const submitButton = this.querySelector('[type="submit"]')
        let showCart = true
        if (submitButton.classList.contains('loading')) return

        if (submitButton.classList.contains('no-cart')) {
          showCart = false
        }

        this.handleErrorMessage()
        this.cartPopup.setActiveElement(document.activeElement)

        submitButton.setAttribute('aria-disabled', true)
        submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        formData.append(
          'sections',
          this.cartPopup.getSectionsToRender().map(section => section.section)
        )
        formData.append('sections_url', window.location.pathname)
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.handleErrorMessage(response.description)
              return
            }
            this.cartPopup.renderContents(response, showCart)
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add('hidden')
            submitButton.classList.add('clicked')
            const cartChangeEvent = new CustomEvent('tk:cart-updated')
            document.dispatchEvent(cartChangeEvent)
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
